<template>
    <div class="container fluid">
        <div class="row justify-content-center">
            <div class="how-to-earn-points-container col-8 col-md-6" v-on:click="toggleShowHowToEarnPointsModal()">
        <span class="how-to-earn-points-text">HOW DO I EARN POINTS?
          <BIconChevronDown class="chev-down-white"/>
        </span>
            </div>
        </div>
        <HowToEarnPointsModal v-if="showHowToEarnPointsModal"></HowToEarnPointsModal>
        <div class="text-box">
            <p class="description-text">Click on the plus & minus sign to add or minus your predictions.</p>
        </div>
        <hr class="line-break">
        <div v-for="(fixture, index) in roundFixtures" :key="index" class="match-box">
            <div class="date-time col-11">
                <p class="date-text">{{ formatDate(fixture.StartDate) }}</p>
            </div>
            <div v-if="fixture.FixtureStarted === 0" class="predictions-closed-box col-11">
                <p class="predictions-closed-text">Predictions for this match are closed!</p>
            </div>
            <div class="team-img-box col-3">
                <img v-if="getTeamLogo(fixture.Team1Name)" :src="getTeamLogo(fixture.Team1Name)" alt="" class="team-logo">
                <div v-if="!getTeamLogo(fixture.Team1Name)" class="generic-logo-team-box">
                    <img class="generic-logo" :src="getGenericLogo()" alt="">
                    <p class="generic-team-text"> {{fixture.Team1Name}}</p>
                </div>
            </div>
            <div class="score-prediction-box col-9">
                <div class="score-button score-button-left col-4" v-on:click="addScoreCount(index, 1, fixture.FixtureStarted)">
                    <img src="../../assets/vodacom/plus-icon-white.png" alt="" class="plus-icon">
                </div>
                <div class="score col-4">
                    <p class="score-number">{{ fixture.team1Score }}</p>
                </div>
                <div class="score-button score-button-right col-4" v-on:click="subtractScoreCount(index, 1, fixture.FixtureStarted)">
                    <img src="../../assets/vodacom/minus-icon-grey.png" alt="" class="minus-icon">
                </div>
            </div>
            <div class="vs-text-box col-3">
                <p class="vs-text">VS</p>
            </div>
            <div class="col-9"></div>
            <div class="team-img-box col-3">
                <img v-if="getTeamLogo(fixture.Team2Name)" :src="getTeamLogo(fixture.Team2Name)" alt="" class="team-logo">
                <div v-if="!getTeamLogo(fixture.Team2Name)" class="generic-logo-team-box">
                    <img class="generic-logo" :src="getGenericLogo()" alt="">
                    <p class="generic-team-text"> {{fixture.Team2Name}}</p>
                </div>
            </div>
            <div class="score-prediction-box col-9 d-flex justify-content-center align-items-center">
                <div class="score-button score-button-left col-4" v-on:click="addScoreCount(index, 2, fixture.FixtureStarted)">
                    <img src="../../assets/vodacom/plus-icon-white.png" alt="" class="plus-icon">
                </div>
                <div class="score col-4">
                    <p class="score-number">{{ fixture.team2Score }}</p>
                </div>
                <div class="score-button score-button-right col-4" v-on:click="subtractScoreCount(index, 2, fixture.FixtureStarted)">
                    <img src="../../assets/vodacom/minus-icon-grey.png" alt="" class="minus-icon">
                </div>
            </div>
        </div>
        <div class="submit-button-box col-12" v-on:click="submitScorePredictions()">
            <button class="submit-button"><p class="button-text">Submit
                predictions</p></button>
        </div>
    </div>
</template>

<script>
    import ScorePredictorService from "../../services/scorePredictorService";
    import moment from 'moment'
    import {mapMutations, mapState} from "vuex";
    import {sports} from "../../config/sports";
    import {BIconChevronDown} from 'bootstrap-vue';
    import HowToEarnPointsModal from "@/components/HowToEarnPointsModal";

    export default {
        name: "Predictions",
        components: {BIconChevronDown, HowToEarnPointsModal},
        data() {
            return {
                roundFixtures: [],
            }
        },
        computed: mapState(['userData', 'selectedSport', 'selectedLeague', 'selectedRound', 'roundPredictions', 'showHowToEarnPointsModal']),
        methods: {
            ...mapMutations(['setPointsScoringBreakdown', 'toggleShowHowToEarnPointsModal', 'clearRoundPredictions']),
            getTeamLogo(teamName) {
                const teamConfig = sports.get(this.selectedSport).get(this.selectedLeague).get(teamName);
                if (!teamConfig) return undefined;
                if (teamConfig.logo === 'teams/Champions-League-Teams/NEEDS-ASSET.png') return undefined;
                if (teamConfig.logo === 'teams/EPL-Teams/NEEDS-ASSET.png') return undefined;
                if (teamConfig.logo === 'teams/Bundasliga-teams/NEEDS-ASSET.png') return undefined;
                if (teamConfig.logo === 'teams/French-ligue-1/NEEDS-ASSET.png') return undefined;
                if (teamConfig.logo === 'teams/Italian-serie-A/NEEDS-ASSET.png') return undefined;
                if (teamConfig.logo === 'teams/Spanish-LaLiga/NEEDS-ASSET.png') return undefined;
                else return require(`../../assets/${teamConfig.logo}`)
            },
            getGenericLogo() {
                return require(`../../assets/teams/Champions-League-Teams/generic-logo.png`)
            },
            addScoreCount(index, teamNumber, predictionsClosed) {
                if (predictionsClosed === 1) teamNumber === 1 ? ++this.roundFixtures[index].team1Score : ++this.roundFixtures[index].team2Score;
            },
            subtractScoreCount(index, teamNumber, predictionsClosed) {
                if (predictionsClosed === 1) {
                    if (teamNumber === 1) {
                        if (this.roundFixtures[index].team1Score > 0) --this.roundFixtures[index].team1Score
                    } else if (this.roundFixtures[index].team2Score > 0) {
                        --this.roundFixtures[index].team2Score
                    }
                }
            },
            async submitScorePredictions() {
                const fixture = {};
                await this.roundFixtures.asyncForEach(async (match) => {
                    fixture.msisdn = this.userData.msisdn;
                    fixture.roundId = this.selectedRound.RoundID;
                    fixture.soccerFixtureId = match.SoccerFixtureID;
                    fixture.eventTypeId = 1;
                    fixture.team1Id = this.getTeamId(match.Team1Name);
                    fixture.team2Id = this.getTeamId(match.Team2Name);
                    fixture.team1Score = match.team1Score;
                    fixture.team2Score = match.team2Score;
                    await ScorePredictorService.enterSoccerRoundPredictions(fixture, this.userData.msisdn);
                });

                this.$router.push('view-predictions');
            },
            getTeamId(teamName) {
                return sports.get(this.selectedSport).get(this.selectedLeague).get(teamName).teamId;
            },
            formatDate(date) {
                return moment(date).format('LLLL')
            },
            addRoundFixtures(fixtures) {
                if (this.roundPredictions.length > 1) {
                    fixtures.forEach((fixture, index) => {
                        fixture.team1Score = this.roundPredictions[index] ? this.roundPredictions[index].Team1Score : 0;
                        fixture.team2Score = this.roundPredictions[index] ? this.roundPredictions[index].Team2Score : 0;
                        this.roundFixtures.push(fixture);
                    });
                } else {
                    fixtures.forEach((fixture) => {
                        fixture.team1Score = 0;
                        fixture.team2Score = 0;
                        this.roundFixtures.push(fixture);
                    });
                }
            },
            async getRoundFixtures() {
                const response = await ScorePredictorService.getRoundFixtures(this.selectedRound.RoundID, this.userData.msisdn);
                this.addRoundFixtures(response.fixtures);
                this.setPointsScoringBreakdown(response.pointsScoringBreakdown);
            },
            clearState() {
                this.roundFixtures = [];
            },
        },
        mounted() {
            this.clearState();
            this.getRoundFixtures();
        }
    }
</script>

<style scoped lang="scss">
    .how-to-earn-points-container {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: $icon-container-background-color;
        padding: 0.5rem 0;
        border-radius: 0 0 3px 3px;
        box-shadow: 4px 4px 4px black;
        margin-bottom: 0.5rem;
    }

    .how-to-earn-points-text {
        color: $heading-text-color;
    }

    .text-box {
        display: flex;
        justify-content: center;
        align-content: center;
        margin: 1vw;
        padding: 1vw;
    }

    .predictions-container {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        justify-content: center;
        align-content: center;
    }

    .match-box {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        align-items: stretch;
    }

    .score-button-left {
        border-radius: 5px 0 0 5px;
    }

    .score-button-right {
        border-radius: 0 5px 5px 0;
    }

    .score-button {
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        background-color: $add-substract-score-background-color;
        height: 9vh;
    }

    .score-button:active {
        background-color: $add-substract-score-background-hover-color;
    }

    .score {
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        background-color: $score-predction-background-color;
        height: 9vh;
    }

    .generic-logo-team-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .generic-logo {
        height: 6vh;
    }

    .generic-team-text {
        margin: 0;
        padding: 0;
        height: 2vh;
        font-size: small;
    }

    .team-img-box {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 10vh;
        border: solid 2px $team-icon-bored-color;
        border-radius: 5px;
    }

    .score-prediction-box {
        display: flex;
        width: 100%;
    }

    .submit-button-box {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .submit-button {
        height: 10vh;
        margin-top: 2vw;
        margin-bottom: 2vw;
        border-radius: 5px;
        background-color: $submit-button-red;
        width: 90%;
        border: none !important;
    }

    .team-logo {
        height: 90%;
    }

    .plus-icon {
        height: 30px;
        width: 30px;
    }

    .minus-icon {
        width: 30px;
        height: 5px;
    }

    @media screen and (max-width: 900px) {
        .plus-icon {
            height: 20px;
            width: 20px;
        }

        .minus-icon {
            width: 20px;
            height: 5px;
        }
    }

    .date-time {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 2vh;
    }

    .predictions-closed-box {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .score-number {
        color: $team-score-prediction-text-color;
        font-size: 6vh;
        margin: 0;
    }

    .vs-text-box {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0;
    }

    .vs-text {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0;
        padding: 0;
        color: $versus-text-color;
        font-size: large;
    }

    .description-text {
        z-index: 0;
        font-size: large;
    }

    .line-break {
        color: $line-break-color;
    }

    .date-text {
        font-size: large;
        margin: 0;
        padding: 0;
    }

    .predictions-closed-text {
        font-size: large;
        color: red;
        padding: 0;
        margin-bottom: 1vh;
    }

    .button-text {
        font-size: large;
        margin: 0;
    }

</style>
